{
  "reports.title": "报表",
  "reports.description": "按时间、项目、分类、渠道和客服组分析工单量与团队工作量。",
  "reports.tab.volume": "工单量趋势与分布",
  "reports.tab.workload": "坐席与客服组工作量",
  "reports.refresh": "刷新",
  "reports.freshness": "数据更新于 {time}",
  "reports.scope.all": "统计范围：全部工单",
  "reports.scope.mine": "统计范围：我可见的工单",
  "reports.scope.description": "报表与工单列表使用同一套可见范围规则；只有被授予「全局可见」的账号才统计全量。",
  "reports.filter.range": "时间范围",
  "reports.filter.range.last7": "近 7 天",
  "reports.filter.range.last30": "近 30 天",
  "reports.filter.range.quarter": "本季度",
  "reports.filter.range.custom": "自定义",
  "reports.filter.range.apply": "应用",
  "reports.filter.range.tooLong": "时间跨度不能超过 {days} 天",
  "reports.filter.range.invalid": "请先选择完整的起止日期",
  "reports.filter.granularity": "粒度",
  "reports.filter.granularity.day": "按天",
  "reports.filter.granularity.week": "按周",
  "reports.filter.granularity.month": "按月",
  "reports.filter.granularity.raised": "跨度较大，已自动按{granularity}汇总",
  "reports.filter.project": "项目",
  "reports.filter.category": "分类",
  "reports.filter.team": "客服组",
  "reports.filter.channel": "渠道",
  "reports.filter.priority": "优先级",
  "reports.filter.all": "全部",
  "reports.filter.selected": "已选 {count} 项",
  "reports.filter.compare": "与上一周期对比",
  "reports.filter.reset": "重置筛选",
  "reports.metric.created": "新建量",
  "reports.metric.resolved": "解决量",
  "reports.metric.reopened": "重开量",
  "reports.metric.reopenRate": "重开率",
  "reports.metric.netBacklogDelta": "净积压变化",
  "reports.metric.openBacklog": "未结存量",
  "reports.metric.unassigned": "待认领",
  "reports.metric.unrouted": "待路由",
  "reports.metric.awaitingFirstResponse": "未响应",
  "reports.metric.badge.current": "当前",
  "reports.metric.badge.range": "所选范围",
  "reports.metric.comparedWithPrevious": "较上一周期",
  "reports.metric.noComparison": "无可比数据",
  "reports.metric.resolvedHint": "按「解决动作」计数：同一工单被重开后再次解决会计入两次。",
  "reports.volume.title": "工单量趋势",
  "reports.volume.created": "新建",
  "reports.volume.resolved": "解决",
  "reports.volume.netBacklog": "净积压",
  "reports.volume.previous": "上一周期",
  "reports.volume.empty": "所选范围内没有工单数据",
  "reports.distribution.title": "构成分布",
  "reports.distribution.dimension.project": "按项目",
  "reports.distribution.dimension.category": "按分类",
  "reports.distribution.dimension.channel": "按渠道",
  "reports.distribution.dimension.priority": "按优先级",
  "reports.distribution.other": "其他",
  "reports.distribution.empty": "所选范围内没有可分布的数据",
  "reports.table.dimension": "维度",
  "reports.table.created": "新建",
  "reports.table.resolved": "解决",
  "reports.table.reopened": "重开",
  "reports.table.openBacklog": "当前未结",
  "reports.table.resolutionP50": "解决时长 P50",
  "reports.table.share": "占比",
  "reports.workload.noticeTitle": "口径说明",
  "reports.workload.notice": "承接、解决、回复按「谁做的算谁的」统计；在手量与组内待认领按当前归属统计。工单转组或改派后，存量口径会跟着新归属走。",
  "reports.workload.scopeNotice": "你没有全局可见权限，下表只包含你所在客服组的成员。",
  "reports.workload.teams": "客服组",
  "reports.workload.agents": "坐席",
  "reports.workload.load": "当前负载分布",
  "reports.workload.loadDescription": "每位坐席当前在手的未结工单数，用于均衡参考。",
  "reports.workload.average": "平均 {value}",
  "reports.workload.column.team": "客服组",
  "reports.workload.column.agent": "坐席",
  "reports.workload.column.taken": "承接",
  "reports.workload.column.resolved": "解决",
  "reports.workload.column.replies": "回复",
  "reports.workload.column.activeAssigned": "当前在手",
  "reports.workload.column.unassigned": "组内待认领",
  "reports.workload.column.resolutionP50": "解决时长 P50",
  "reports.workload.empty": "所选范围内没有工作量数据",
  "reports.duration.minutes": "{count} 分钟",
  "reports.duration.hours": "{count} 小时",
  "reports.duration.days": "{count} 天",
  "reports.duration.none": "—",
  "reports.drillDown": "在工单列表中查看",
  "reports.tab.insight": "问题洞察",
  "reports.insight.description": "用户正在遇到哪些问题、哪些在恶化——用于产品迭代，不是团队考核。",
  "reports.insight.restricted.title": "需要全局可见权限",
  "reports.insight.restricted.description": "问题洞察只对拥有「全局可见」的账号开放。按个人可见范围算出的问题排行只是局部视角，容易被当成产品全貌，反而会把资源引向错误的地方。",
  "reports.insight.dimension.category": "按分类",
  "reports.insight.dimension.tag": "按标签",
  "reports.insight.ranking.title": "问题排行",
  "reports.insight.ranking.description": "默认按受影响用户数排序。一个大客户提 40 单和 40 个用户各提 1 单，对产品的意义完全不同。",
  "reports.insight.column.issue": "问题",
  "reports.insight.column.affectedUsers": "受影响用户",
  "reports.insight.column.anonymousTickets": "匿名工单",
  "reports.insight.column.tickets": "工单量",
  "reports.insight.column.growth": "环比",
  "reports.insight.column.reopenRate": "重开率",
  "reports.insight.column.resolutionP50": "解决时长 P50",
  "reports.insight.column.duplicates": "重复单",
  "reports.insight.uncategorized": "未分类",
  "reports.insight.uncategorizedHint": "自动分类失效时，这一桶的异常本身就是最该看到的信号，因此始终单独列出。",
  "reports.insight.affectedUsersHint": "只统计有业务身份的客户。匿名提单每次都会新建一个独立客户档案，混进来会系统性高估，因此单独成列——两个数不能相加。",
  "reports.insight.new": "新出现",
  "reports.insight.newHint": "上一周期没有这个问题。新版本引入的缺陷通常长这样。",
  "reports.insight.surging.title": "正在恶化",
  "reports.insight.surging.description": "环比增幅同时超过倍数与绝对增量门槛的问题。",
  "reports.insight.surging.empty": "所选范围内没有明显恶化的问题",
  "reports.insight.emerging.title": "本期新出现",
  "reports.insight.emerging.description": "上一周期为零、这一周期冒出来的问题。",
  "reports.insight.emerging.empty": "所选范围内没有新出现的问题",
  "reports.insight.stubborn.title": "难缠问题",
  "reports.insight.stubborn.description": "重开率高、解决耗时长——反复修反复来，值得从根上改。",
  "reports.insight.location.title": "问题落点",
  "reports.insight.location.pending": "按 App 版本、来源页面定位问题，需要先与接入的业务系统约定扩展字段的键名，并为该字段建立生成列索引（见设计文档 §6.6）。约定完成前这里不展示数据，而不是给一张空图。",
  "reports.insight.duplicatesPending": "待实现",
  "reports.insight.duplicatesHint": "重复工单标记尚未落地，因此这里显示「待实现」而不是 0——0 会被读成「没有重复问题」。",
  "reports.insight.empty": "所选范围内没有问题数据",
  "reports.insight.untagged": "未打标签",
  "reports.insight.untaggedHint": "没有任何标签的工单。这一桶越大，上面的标签排行越不能代表全貌。",
  "reports.truncated": "数据量过大，本次未计算解决时长中位数（显示为「—」）。请缩小时间范围或增加筛选条件。"
}
